import { Link } from 'react-router';
import { License } from '../../lib/types';
import Tooltip from '../tooltip/Tooltip';
import Badge from './Badge';

export const LicenseBadge = ({
    license,
    className,
}: {
    license: License;
    className?: string;
}) => {
    const endsSoon = license && license.date_license_ends ?
        new Date(license.date_license_ends) <
        new Date(Date.now() + 20 * 24 * 60 * 60 * 1000) : false;
    return (
        <Badge className={className}>
            <span className="flex items-center gap-2">
                {license.type_for_human}{' '}
                {endsSoon && (
                    <Tooltip label="Platnost brzy skončí">
                        <Link to="/koupit/plna-verze">
                            <span className="flex h-2.5 w-2.5 shrink-0 rounded-full bg-orange-300"></span>
                        </Link>
                    </Tooltip>
                )}
            </span>
        </Badge>
    );
};
